import { Component, Input, OnInit } from '@angular/core';
import { ICrossSellDecline, ICrossSellLayout } from 'src/app/domain/interfaces/crossell/interface-cross-sell';
import { CrossSellsService } from 'src/app/infraestructure/drive-adapter/crossell-service/cross-sells.service';

@Component({
  selector: 'app-crosssell7',
  templateUrl: './crosssell7.component.html',
  styleUrls: ['./crosssell7.component.scss']
})
export class Crosssell7Component implements OnInit {
  @Input() Company!: string;
  @Input() CrossSellsToShow: Array<ICrossSellLayout> = [];
  public offers: ICrossSellDecline[] = [];
  public card: ICrossSellDecline = {};

  constructor(private crossSellsService: CrossSellsService) {}

  ngOnInit(): void {
    this.crossSellsService.getCrossSellsDeclineDataFromJSON().subscribe((crossSellsDeclineData: Array<ICrossSellDecline>) => {
      this.offers = crossSellsDeclineData; 
      this.matchAndAssignTrackingLink();
    });
  }
  
  private matchAndAssignTrackingLink(): void {
    this.offers.forEach(offer => {
      const matchingCrossSells = this.CrossSellsToShow.filter(crossSell =>
        crossSell.name == offer.vertical && this.Company == offer.company && crossSell.isActive && crossSell.trackingLink !== ''
      );
  
      if (matchingCrossSells.length > 0) {
        matchingCrossSells.forEach(matchingCrossSell => {
          this.card = { ...offer, trackingLink: matchingCrossSell.trackingLink };
        });
      }
    });
  }  
}
